import React from 'react'

export default function CommonModal({ content=null,isOpen=false, size= null ,  action=null, title="" }) {
    return (
        <>
            
            {(isOpen) ?
                <div className="fixed inset-0 z-50 flex items-center justify-center" isOpen={isOpen} onRequestClose={action} contentLabel="My Modal">
                    <div className="fixed inset-0 bg-black opacity-50 modal"></div>
                    <div className={`modal-content bg-white rounded-lg shadow-lg z-10 ${size ? size : "lg:w-[70%] w-[90%]"}`}>
                        <div className="flex justify-between p-4 modal-header">
                            <h2 className="text-lg font-semibold text-[#1b5df3]">{title}</h2>
                            <button className="text-xl text-red-400 hover:text-red-400" onClick={action}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-6 h-6 "
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <hr />
                        <div className="w-full h-full p-5 overflow-x-hidden overflow-y-auto modal-body max-h-96">
                            {content}
                        </div>
                    </div>
                </div> :
                ""
            }

        </>
    )
}
